// bao migrate skip
import "./../../bindings/bao-upload";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import BaoDialogViewModel from "../../factories/bao-dialog";
class CITManufacturerTypeReferenceDocumentDialog {
    constructor(data: any, dialog: BaoDialogViewModel) {
        this.Dialog = dialog;
        $.extend(this, data);
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck; //TODO: schöner Machen! Anpassung in dialog notwendig. Vermutlich über neuen Dialog (baoDialog2)
    }
    Dialog: BaoDialogViewModel;
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    };
    Upload(): JQueryPromise<any> {
        //Dummy
        return null;
    }
    init() {
    }
    loaded() {
    }
    startDownload() {
    }
}
export default CITManufacturerTypeReferenceDocumentDialog;